import { scopeLabel } from "./labels";

// What leaving the page loses ("Exit Without Saving"): the drafts the
// destination leaves, and, when a modified form is left (a real navigation),
// the draft of its scope too: the two halves of an operation (e.g. a drag in
// the tree: the tree in the form, the order of the variants in the draft)
// never outlive each other.
// { ask, discard: [scope], message }: message names the drafts lost
// (undefined: the form alone, the default wording).
export function planExit({
  formDirty = false,
  formScope = null,
  draftsLeft = [],
  navigating = false,
  isDirty = () => false,
  propertyTitle
}) {
  const discard = [...draftsLeft];
  if (
    formDirty &&
    navigating &&
    formScope &&
    isDirty(formScope) &&
    !discard.includes(formScope)
  )
    discard.push(formScope);

  const ask = formDirty || draftsLeft.length > 0;
  if (discard.length === 0) return { ask, discard, message: undefined };

  const names = discard.map((scope) => scopeLabel(scope, propertyTitle));
  const message = `You have unsaved changes in ${names.join(", ")}${
    formDirty ? " and in the form you are editing" : ""
  }. If you exit without saving you lose them.`;

  return { ask, discard, message };
}

// The draft scope a modified form is coupled with right now, or null. A form
// and the draft of its scope are coupled only when an operation split itself
// between them (couple(values, initialValues): e.g. the property tree dragged:
// the tree in the form, the order of the variants in the draft); then Reset,
// Discard and leaving the form take both. Otherwise they are independent.
export function coupledScope({
  dirty,
  draftScope,
  couple,
  values,
  initialValues
}) {
  if (!dirty || !draftScope || !couple) return null;
  return couple(values, initialValues) ? draftScope : null;
}
